import { render } from "./CasualPayrolls.vue?vue&type=template&id=0624b15e&scoped=true"
import script from "./CasualPayrolls.vue?vue&type=script&lang=js"
export * from "./CasualPayrolls.vue?vue&type=script&lang=js"

import "./CasualPayrolls.vue?vue&type=style&index=0&id=0624b15e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0624b15e"]])

export default __exports__